import { EvCarProfile, EvCarProfileStatus } from '@/models/evCarProfile'

import { formatKeysForTable } from '@/helpers/data-table'

export function formatVehicleForTheTable(
  car: EvCarProfile,
  picked: (keyof EvCarProfile)[]
) {
  const tableData = formatKeysForTable(car, picked)

  return tableData
}

// Night renter assignment label, or null when there is none.
// "Scheduled" until the night starts, "Assigned" while in force; times in Asia/Baku like the backend.
export function getAssignmentLabel(car: EvCarProfile): string | null {
  const {
    assigned_user: user,
    assigned_from: from,
    assigned_until: until,
  } = car
  const now = new Date()

  if (
    !ASSIGNABLE_STATUSES.includes(car.status as EvCarProfileStatus) ||
    !user ||
    !from ||
    !until ||
    new Date(until) <= now
  ) {
    return null
  }

  const bakuTime = (iso: string) =>
    new Date(iso).toLocaleTimeString('en-GB', {
      timeZone: 'Asia/Baku',
      hour: '2-digit',
      minute: '2-digit',
    })
  const state = new Date(from) > now ? 'Scheduled' : 'Assigned'
  const name = [user.first_name, user.last_name].filter(Boolean).join(' ')

  return `${state} → ${name} (${user.phone}) ${bakuTime(from)}–${bakuTime(
    until
  )}`
}

// Statuses for which the admin can set a night renter (see backend setAssignedUser)
export const ASSIGNABLE_STATUSES = [
  EvCarProfileStatus.ACTIVE,
  EvCarProfileStatus.INACTIVE,
  EvCarProfileStatus.ADMIN_ACTIVE,
]
